<template>
	<div class="pagetree-search-container pagetree-search">
		<input
			type="text"
			autocomplete="pagetree-search"
			class="pagetree-search-input"
			v-bind:value="modelValue"
      v-on:input="$emit('update:modelValue', $event.target.value)"
			:placeholder="$t('pagetree.searchPlaceholder')"
		/>
		<span
			class="input-clear-btn"
			v-if="modelValue.length > 0"
			v-on:click="clear()"
		></span>
	</div>
</template>

<script>
export default {
	props: ["modelValue"],
	methods: {
		clear: function () {
			this.$emit("update:modelValue", "")
		}
	}
};
</script>

<style scoped>
.pagetree-search-input {
	width: 100%;
	margin-bottom: 10px;
	border-radius: 6px;
	padding: 5px 10px;
	border: 1px solid #C1C7D0;
	outline: none;
	transition: border-color 0.15s ease, box-shadow 0.15s ease;
}

.pagetree-search-input:focus {
	border-color: #2563EB;
}

.pagetree-search-input::-ms-clear {
	display: none;
	height: 0;
	width: 0;
}
.pagetree-search .input-clear-btn {
	position: absolute;
	right: 0;
	margin-top: 3px;
	margin-right: 3px;
}

.pagetree-search .input-clear-btn::before {
	content: " ";
	display: inline-block;
	cursor: pointer;
	height: 1.5em;
	width: 1.5em;
	/*   /misc/icons/24_cancel_gray.svg   */
	background-image: url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiIHN0YW5kYWxvbmU9Im5vIj8+CjxzdmcKICAgeG1sbnM6ZGM9Imh0dHA6Ly9wdXJsLm9yZy9kYy9lbGVtZW50cy8xLjEvIgogICB4bWxuczpjYz0iaHR0cDovL2NyZWF0aXZlY29tbW9ucy5vcmcvbnMjIgogICB4bWxuczpyZGY9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkvMDIvMjItcmRmLXN5bnRheC1ucyMiCiAgIHhtbG5zOnN2Zz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciCiAgIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICAgdmVyc2lvbj0iMS4xIgogICB4PSIwcHgiCiAgIHk9IjBweCIKICAgd2lkdGg9IjI2IgogICBoZWlnaHQ9IjI2IgogICB2aWV3Qm94PSIwIDAgMjYgMjYiCiAgIGVuYWJsZS1iYWNrZ3JvdW5kPSJuZXcgMCAwIDE0MCAyNCIKICAgeG1sOnNwYWNlPSJwcmVzZXJ2ZSIKICAgaWQ9InN2ZzQ0Ij48bWV0YWRhdGEKICAgaWQ9Im1ldGFkYXRhNTAiPjxyZGY6UkRGPjxjYzpXb3JrCiAgICAgICByZGY6YWJvdXQ9IiI+PGRjOmZvcm1hdD5pbWFnZS9zdmcreG1sPC9kYzpmb3JtYXQ+PGRjOnR5cGUKICAgICAgICAgcmRmOnJlc291cmNlPSJodHRwOi8vcHVybC5vcmcvZGMvZGNtaXR5cGUvU3RpbGxJbWFnZSIgLz48ZGM6dGl0bGU+PC9kYzp0aXRsZT48L2NjOldvcms+PC9yZGY6UkRGPjwvbWV0YWRhdGE+PGRlZnMKICAgaWQ9ImRlZnM0OCIgLz4KPGcKICAgc3R5bGU9ImZpbGw6IzY2NjY2NiIKICAgaWQ9IkNhbmNlbF9HcmV5IgogICB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxLDEpIj4KCTxnCiAgIGlkPSJnNiIKICAgc3R5bGU9ImZpbGw6IzY2NjY2NiI+CgkJPGcKICAgaWQ9Imc0IgogICBzdHlsZT0iZmlsbDojNjY2NjY2Ij4KCQkJPHBhdGgKICAgZmlsbC1ydWxlPSJldmVub2RkIgogICBjbGlwLXJ1bGU9ImV2ZW5vZGQiCiAgIGZpbGw9IiM3MzczNzMiCiAgIGQ9Im0gMTYuMSw3LjkgYyAtMC40LC0wLjQgLTEsLTAuNCAtMS40LDAgTCAxMiwxMC42IDkuNCw4IEMgOSw3LjYgOC40LDcuNiA4LDggNy42LDguNCA3LjYsOSA4LDkuNCBMIDEwLjYsMTIgOCwxNC42IGMgLTAuNCwwLjQgLTAuNCwxIDAsMS40IDAuNCwwLjQgMSwwLjQgMS40LDAgTCAxMiwxMy40IDE0LjYsMTYgYyAwLjQsMC40IDEsMC40IDEuNCwwIDAuNCwtMC40IDAuNCwtMSAwLC0xLjQgTCAxMy40LDEyIDE2LjEsOS4zIGMgMC40LC0wLjMgMC40LC0xIDAsLTEuNCB6IE0gMTIsMCBDIDUuNCwwIDAsNS40IDAsMTIgMCwxOC42IDUuNCwyNCAxMiwyNCAxOC42LDI0IDI0LDE4LjYgMjQsMTIgMjQsNS40IDE4LjYsMCAxMiwwIFogbSAwLDIyIEMgNi41LDIyIDIsMTcuNSAyLDEyIDIsNi41IDYuNSwyIDEyLDIgYyA1LjUsMCAxMCw0LjUgMTAsMTAgMCw1LjUgLTQuNSwxMCAtMTAsMTAgeiIKICAgaWQ9InBhdGgyIgogICBzdHlsZT0iZmlsbDojNjY2NjY2IiAvPgoJCTwvZz4KCTwvZz4KCQoJCgkKCQo8L2c+Cjwvc3ZnPgo=);
	background-size: cover;
	/*filter: grayscale(1) brightness(2.5);*/
}
</style>
